import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/okhvat"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5433 4.7039C14.8448 5.43185 15 6.21207 15 7H9L9 1C9.78793 1 10.5681 1.15519 11.2961 1.45672C12.0241 1.75825 12.6855 2.20021 13.2426 2.75736C13.7998 3.31451 14.2418 3.97595 14.5433 4.7039ZM11.9888 12.3334C12.6481 11.3467 13 10.1867 13 9H7V3C5.81331 3 4.65328 3.35189 3.66658 4.01118C2.67989 4.67047 1.91085 5.60754 1.45673 6.7039C1.0026 7.80026 0.88378 9.00666 1.11529 10.1705C1.3468 11.3344 1.91825 12.4035 2.75736 13.2426C3.59648 14.0818 4.66557 14.6532 5.82946 14.8847C6.99335 15.1162 8.19975 14.9974 9.2961 14.5433C10.3925 14.0892 11.3295 13.3201 11.9888 12.3334Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Okhvat16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Okhvat16 = createIcon(IconComponent);